import { useReducer } from 'react'
import filtersReducer, { filtersDefault } from './filters'
import pageReducer, { pageDefault } from './page'
import inventoryReducer, { inventoryDefault } from './inventory'
import productReducer, { productDefault } from './product'
import idealPortfolioReducer, { idealPortfolioDefault } from './idealPortfolio'

export default function (initialValue) {
  const [filtersStore, filtersDispatch] = useReducer(
    filtersReducer,
    initialValue?.filtersStore ? initialValue.filtersStore : filtersDefault
  )

  const [pageStore, pageDispatch] = useReducer(
    pageReducer,
    initialValue?.pageStore ? initialValue.pageStore : pageDefault
  )

  const [inventoryStore, inventoryDispatch] = useReducer(
    inventoryReducer,
    initialValue?.inventoryStore
      ? initialValue.inventoryStore
      : inventoryDefault
  )

  const [productStore, productDispatch] = useReducer(
    productReducer,
    initialValue?.productStore ? initialValue.productStore : productDefault
  )

  const [idealPortfolioStore, idealPortfolioDispatch] = useReducer(
    idealPortfolioReducer,
    initialValue?.idealPortfolioStore
      ? initialValue.idealPortfolioStore
      : idealPortfolioDefault
  )

  return {
    store: {
      filtersStore,
      pageStore,
      inventoryStore,
      productStore,
      idealPortfolioStore,
    },
    reducers: {
      filtersDispatch,
      pageDispatch,
      inventoryDispatch,
      productDispatch,
      idealPortfolioDispatch,
    },
  }
}
